<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.p1_html" [separator]="false" />
  </ng-container>

  <ng-container body>
    <email-margin [height]="18" />
    <email-text [contents]="data.p2 | mailgunMarkAsHtml" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="paragraph" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
